<template>
  <v-dialog persistent v-model="dialogVisible" max-width="50rem">
    <v-card>
      <v-card-title>Please verify Chapter and Lesson Name</v-card-title>
      <v-card-subtitle class="ma-2">
        Chapter : {{ selectedChapterName }}
      </v-card-subtitle>
      <v-card-subtitle class="ma-2">
        Lesson : {{ selectedLessonName }}
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeEndClassConfirm()"
          >Cancel</v-btn
        >
        <v-btn color="primary" text @click="endClass()">OK</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ClassEndConfirmDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectedChapterName: {
      type: String,
      default: "",
    },
    selectedLessonName: {
      type: String,
      default: "",
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeEndClassConfirm() {
      this.dialogVisible = false;
    },
    endClass() {
      this.$emit("confirm");
    },
  },
};
</script>